import React from 'react'

// assets
import Strings from '../../assets/strings.json'

const Ring = () => {
  return (
    <button className="cta-button whitespace-no-wrap w-full max-w-xxs h-16 flex items-center justify-center border-red bg-transparent border-2 text-xl1/5 text-black pr-5 pl-4 rounded-md">
      <span className="text-red text-xs inline-block mr-6 font-semibold">{ Strings[document.body.dataset.lang].emergency }</span>
      { Strings[document.body.dataset.lang].call110 }
    </button>
  )
}

export default Ring
